import React, { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import Select from "react-select";
import { savesettings } from '../../services/AdminApiServices';
import {saveprintsettings} from '../../services/AdminApiServices';
import toast from 'react-hot-toast';
import {getPrintSettingsByBranch} from '../../services/AdminApiServices';
const SettingPrint = ({ editBranch }) => {
  const { register, handleSubmit, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
 
  const { branchsettings } = useSelector((state) => state.settings);
  const { branch } = useSelector((state) => state.branchlist);
  // Save to the branch being edited on the Branch screen, not the signed-in one (SS-7 / F-8).
  const targetBranch = editBranch || branch;
const [printSettings, setPrintSettings] = useState();


  useEffect(() => {
    setValue("general", {
      timeToClearPoleDisplay: branchsettings?.timeToClearPoleDisplay,
      timeToRefreshPayScreen: branchsettings?.timeToRefreshPayScreen,
      totalAmountForDiscount: branchsettings?.totalAmountForDiscount,
      enableBillSearchByTable: branchsettings?.enableBillSearchByTable,
      tableAlignmentRowNumber: branchsettings?.tableAlignmentRowNumber,
      tableAlignmentColumnNumber: branchsettings?.tableAlignmentColumnNumber,
      showSaleAmountInPoleDisplay: branchsettings?.showSaleAmountInPoleDisplay,
      enableLoyalty: branchsettings?.enableLoyalty,
      enableChairInSale: branchsettings?.enableChairInSale,
      orderProductByReferenceCode: branchsettings?.orderProductByReferenceCode,
      showChangeSectionButtonInPay: branchsettings?.showChangeSectionButtonInPay,
      showSplitButtonInPay: branchsettings?.showSplitButtonInPay,
      showMergeButtonInPay: branchsettings?.showMergeButtonInPay,
      showPaxPopupInSale: branchsettings?.showPaxPopupInSale,
      numberOfKOTPrints: branchsettings?.numberOfKOTPrints,
      applicationBackgroundImageNumber: branchsettings?.applicationBackgroundImageNumber,
      changeApplicationDesign: branchsettings?.changeApplicationDesign,
      hideModifierDetailsInKOTPrint: branchsettings?.hideModifierDetailsInKOTPrint,
      enableDataAutoSyncWithServer: branchsettings?.enableDataAutoSyncWithServer,
      enableVirtualKeyboard: branchsettings?.enableVirtualKeyboard,
      enableCess: branchsettings?.enableCess,
      enableCounterSection: branchsettings?.enableCounterSection,
      isStockProduct: branchsettings?.isStockProduct,
      showUnitPriceOfProductInSale: branchsettings?.showUnitPriceOfProductInSale,
      enablePrintInKitchenManager: branchsettings?.enablePrintInKitchenManager,
      kitchenManagerPrinter: branchsettings?.kitchenManagerPrinter,
      disableMultipleOrderInTable: branchsettings?.disableMultipleOrderInTable,
      viewSalesOrderFromTable: branchsettings?.viewSalesOrderFromTable,
      showCategoryAsCoursewiseInKOT: branchsettings?.showCategoryAsCoursewiseInKOT,
      enableWaiterwiseLogin: branchsettings?.enableWaiterwiseLogin,
      generateQrCodeInBillPrint: branchsettings?.generateQrCodeInBillPrint,
      sendMailWhileDayClose: branchsettings?.sendMailWhileDayClose,
      emailToSendDailyCloseReport: branchsettings?.emailToSendDailyCloseReport,
      arrangePhoneNumberAboveNameInCustomerMenu: branchsettings?.arrangePhoneNumberAboveNameInCustomerMenu,
      disableTaxEditInCreditBill: branchsettings?.disableTaxEditInCreditBill,
      currencyFormat: branchsettings?.currencyFormat,
      dateFormat: branchsettings?.dateFormat,
      defaultUserType: branchsettings?.defaultUserType,
      enableGeneralKeypad: branchsettings?.enableGeneralKeypad,
      generateSaleBillPrint: branchsettings?.generateSaleBillPrint,
      numberOfDaysExtendForBillingAfterDailyClose: branchsettings?.numberOfDaysExtendForBillingAfterDailyClose,
      numberOfDaysForEditBill: branchsettings?.numberOfDaysForEditBill,
      generateSalesInvoiceInDotMatrixPrinter: branchsettings?.generateSalesInvoiceInDotMatrixPrinter,
      hideItemwiseSummaryInDailyClose: branchsettings?.hideItemwiseSummaryInDailyClose,
      hideSectionSummaryInDailyClose: branchsettings?.hideSectionSummaryInDailyClose,
      showDateInDailyClose: branchsettings?.showDateInDailyClose,
      billNumberSeriesType: branchsettings?.billNumberSeriesType,
      enableArabicMenuDescription: branchsettings?.enableArabicMenuDescription,
      defaultState: branchsettings?.defaultState,
      enableProductNameBilling: branchsettings?.enableProductNameBilling,
      generateKOTOnCashInsale: branchsettings?.generateKOTOnCashInsale,
      showAllProductsInKOTPrint: branchsettings?.showAllProductsInKOTPrint,
      generateKOTPrint: branchsettings?.generateKOTPrint,
      showCancelReasonPopupInPay: branchsettings?.showCancelReasonPopupInPay,
      disableTaxInSale: branchsettings?.disableTaxInSale,
      enableSizeColour: branchsettings?.enableSizeColour,
      disableLastSaleBillPrintOnEnter: branchsettings?.disableLastSaleBillPrintOnEnter,
      hideInvoiceRePrintMenu: branchsettings?.hideInvoiceRePrintMenu,
      showWaiterPopupOnSaveSale: branchsettings?.showWaiterPopupOnSaveSale,
      enableContinuousBillNumberInSale: branchsettings?.enableContinuousBillNumberInSale,
      enableVAT: branchsettings?.enableVAT,
      generateDailyClosePrint: branchsettings?.generateDailyClosePrint,
      showCreditButtonInSales: branchsettings?.showCreditButtonInSales,
      showTaxButtonInSaleForSpecialCustomer: branchsettings?.showTaxButtonInSaleForSpecialCustomer,
      changeProductDetailsWhileBilling: branchsettings?.changeProductDetailsWhileBilling,
      enableTokenNumber: branchsettings?.enableTokenNumber,
      enableSectionWiseTokenNumber: branchsettings?.enableSectionWiseTokenNumber,
      enableOtherLanguage: branchsettings?.enableOtherLanguage,
      showSaleBillInAllCounters: branchsettings?.showSaleBillInAllCounters,
      showSaleBillInAllCounterAndSections: branchsettings?.showSaleBillInAllCounterAndSections,
      showSaleBillInAllSections: branchsettings?.showSaleBillInAllSections,
      deliverySection: branchsettings?.deliverySection,
      showTablePopupInSection: branchsettings?.showTablePopupInSection,
      enableDepartmentInSection: branchsettings?.enableDepartmentInSection,
      disableSalePrintInPayScreen: branchsettings?.disableSalePrintInPayScreen,
      enableShiftClose: branchsettings?.enableShiftClose,
      generatePrintInCashButton: branchsettings?.generatePrintInCashButton,
      enableDailyCloseSummaryPrint: branchsettings?.enableDailyCloseSummaryPrint,
      showWaiterPopupInSection: branchsettings?.showWaiterPopupInSection,
      showCustomerPopupInSection: branchsettings?.showCustomerPopupInSection,
      dailyClosePrintFormat: branchsettings?.dailyClosePrintFormat,
      showFieldToEnterArabicDescriptionInProduct: branchsettings?.showFieldToEnterArabicDescriptionInProduct,
      roundOffInSale: branchsettings?.roundOffInSale,
      comboType: branchsettings?.comboType,
      showKeyBoardForEnterQuantityManually: branchsettings?.showKeyBoardForEnterQuantityManually,
      ledDisplayPort: branchsettings?.ledDisplayPort,
      enablePoleDisplayAutoClear: branchsettings?.enablePoleDisplayAutoClear,
      primaryCurrencyGUID: branchsettings?.primaryCurrencyGUID,
      defaultFinancialYearGuID: branchsettings?.defaultFinancialYearGuID,
    });
//     setValue("print", {
 
//   companyName: branchsettings?.companyName,
//   otherLanguage: branchsettings?.otherLanguage,
//   header1: branchsettings?.header1,
//   header2: branchsettings?.header2,
//   header3: branchsettings?.header3,
//   header4: branchsettings?.header4,
//   header5: branchsettings?.header5,

//   // paperSize: branchsettings?.paperSize || "thermal",
//   // font: branchsettings?.font || "Consolas",
//   // fontSize: branchsettings?.fontSize || 9,
//   // boldText: branchsettings?.boldText || false,
//   // alignment: branchsettings?.alignment || "center",

//   footerText1: branchsettings?.footerText1,
//   footerText2: branchsettings?.footerText2,
//   //showQrCode: branchsettings?.showQrCode || false,
// });

  }, [branchsettings,branch])

  useEffect(() => {
  const fetchPrintSettings = async () => {
    if (!targetBranch) return;

    try {
const response = await getPrintSettingsByBranch(targetBranch?.guid);

if (response && response.length > 0) {
  const data = response[0]; // VERY IMPORTANT

  setPrintSettings(data);

  setValue("print", {
    companyName: data.companyName,
    otherLanguage: data.otherLanguage,
    header1: data.header1,
    header2: data.header2,
    header3: data.header3,
    header4: data.header4,
    header5: data.header5,
    footerText1: data.footerText1,
    footerText2: data.footerText2,
  });
}

    } catch (error) {
      console.error("Failed to fetch print settings:", error);
    }
  };

  fetchPrintSettings();
}, [targetBranch?.guid]);

  const closeButtonRef = useRef();

  const closemodal = () => {
    if (closeButtonRef.current) {
      closeButtonRef.current.click();
    }
  };
//   const handleGeneralSettings=async(data)=>{
    
//     try {
//       const response = await savesettings({setting: data.general, branch: targetBranch});
//       if(response==true){
//         toast.success("success")
//         closemodal()
//       }
   
//     } catch (error) {
//       console.error("Error fetching states:", error);
//     }
//   }

// const handlePrintSettings = async (data) => {
//   try {
//     const payload = {
//       branch: branch,

//       invoicePrintSetup: {
//         templateName: "Thermal Default",

//         companyName: data.print.companyName,
//         otherLanguage: data.print.otherLanguage,
//         header1: data.print.header1,
//         header2: data.print.header2,
//         header3: data.print.header3,
//         header4: data.print.header4,
//         header5: data.print.header5,

//         // phone: branchsettings?.phone,
//         // email: branchsettings?.email,
//         // gstNo: branchsettings?.company?.tin,

//         // Print defaults (you can later make UI for these)
//         paperSize: "THERMAL",
//         fontName: "Consolas",
//         fontSize: 9,
//         isBold: true,
//         alignment: "CENTER",

//         footerText1: data.print.footerText1,
//         footerText2: data.print.footerText2,

//         // showQrCode: data.print.showQrCode,

//       },
//     };

//     const response = await saveprintsettings(payload);

//     if (response === true) {
//       toast.success("Invoice print settings saved");
//       closemodal();
//     }
//   } catch (error) {
//     console.error("Save failed:", error);
//     toast.error("Failed to save settings");
//   }
// };
const onSubmitAllSettings = async (data) => {
  try {
    // 1️⃣ Save General Settings
    const generalResponse = await savesettings({
      setting: data.general,
      branch: targetBranch,
    });

    // 2️⃣ Save Print Settings
    const printPayload = {
      branch: targetBranch,
      invoicePrintSetup: {
        templateName: "Thermal Default",

        companyName: data.print.companyName,
        otherLanguage: data.print.otherLanguage,
        header1: data.print.header1,
        header2: data.print.header2,
        header3: data.print.header3,
        header4: data.print.header4,
        header5: data.print.header5,

        paperSize: "THERMAL",
        fontName: "Consolas",
        fontSize: 9,
        isBold: true,
        alignment: "CENTER",

        footerText1: data.print.footerText1,
        footerText2: data.print.footerText2,
      },
    };

    const printResponse = await saveprintsettings(printPayload);

    if (generalResponse === true && printResponse === true) {
      toast.success("Settings saved successfully");
      closemodal();
    }
  } catch (error) {
    console.error("Save failed:", error);
    toast.error("Failed to save settings");
  }
};



  return (
    <div className="modal-body custom-modal-body">
     <form onSubmit={handleSubmit(onSubmitAllSettings)}>
        <div className='form_body'>
          {/* <div className="row">
            <label><b>Kitchen manager print : </b> </label>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="d-flex">
                <input type="checkbox" {...register("general.enablePrintInKitchenManager")} />
                <label className='m-3'>Enable print in kitchen manager</label>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 general_decription">
              Enabling this setting will generate print in kitchen manager</div>

            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks add-product">
                <label>Kitchen Manager Printer</label>

                <input type="text" {...register("general.kitchenManagerPrinter")} />

              </div>


            </div>
            <hr />
          </div> */}
          {/* <div className="row">
            <label><b>KOT print : </b> </label>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks add-product">
                <label>Number Of KOT Prints</label>

                <select name="" id="" className="form-control" {...register("general.numberOfKOTPrints")}>
                                <option value="" disabled >Select</option>
                                <option value="1" >1</option>
                                <option value="2" >2</option>
                                <option value="3" >3</option>
                                <option value="4" >4</option>
                                <option value="5" >5</option>
                                <option value="6" >6</option>
                                <option value="7" >7</option>
                                <option value="8" >8</option>
                                <option value="9" >9</option>
                                <option value="10" >10</option>
                                
                              </select>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12"></div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="d-flex">
                <input type="checkbox" {...register("general.generateKOTPrint")} />
                <label className='m-3'>Generate KOT print</label>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 general_decription">
              When this setting enabled, kot print will generate when doing a sale </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="d-flex">
                <input type="checkbox" {...register("general.generateKOTOnCashInsale")} />
                <label className='m-3'>Generate KOT on cash in sale</label>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 general_decription">
              Enabling this setting will generate kot print while clicking cash button on Sales screen </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="d-flex">
                <input type="checkbox" {...register("general.showAllProductsInKOTPrint")} />
                <label className='m-3'>Show all products in KOT print</label>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 general_decription">
              When this setting enabled, kot print will show all items in each kot regardless of kitchen </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="d-flex">
                <input type="checkbox" {...register("general.showCategoryAsCoursewiseInKOT")} />
                <label className='m-3'>Show category as course wise in KOT</label>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 general_decription">
              When this setting enabled, kot items will show as in the order of category in kot print, (order we set in category form) </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="d-flex">
                <input type="checkbox" {...register("general.hideModifierDetailsInKOTPrint")} />
                <label className='m-3'>Hide modifier details in KOT print</label>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 general_decription">
              When this setting enabled, product modifier details will not show in KOT print </div>
            <hr />
          </div> */}
          <div className="row">
            <label><b>Sale bill print: </b> </label>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="d-flex">
                <input type="checkbox" {...register("general.generateSalesInvoiceInDotMatrixPrinter")} />
                <label className='m-3'>Generate sales invoice in dot matrix printer</label>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 general_decription">
              When this setting enabled, sale bill print will generate in dot matrix printer </div>
            <hr />

          </div>
          <div className="row">
            <label><b>Application design: </b> </label>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="d-flex">
                <input type="checkbox" {...register("general.changeApplicationDesign")} />
                <label className='m-3'>Change application design</label>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 general_decription">
              This setting is to change application design </div>
            <hr />

          </div>

          <div className="row">
  <label><b>Invoice Print Setup</b></label>

  {/* <div className="col-lg-6">
    <label>Template Name</label>
    <input className="form-control" {...register("print.templateName")} />
  </div> */}

  <div className="col-lg-6">
    <label>Company Name</label>
    <input className="form-control" {...register("print.companyName")} />
  </div>

  <div className="col-lg-6">
    <label>Other Language</label>
    <input className="form-control" {...register("print.otherLanguage")} />
  </div>
  <div className="col-lg-6">
    <label>Address Line 1</label>
    <input className="form-control" {...register("print.header1")} />
  </div>

  <div className="col-lg-6">
    <label>Address Line 2</label>
    <input className="form-control" {...register("print.header2")} />
  </div>

  <div className="col-lg-6">
    <label>Address Line 3</label>
    <input className="form-control" {...register("print.header3")} />
  </div>

  <div className="col-lg-6">
    <label>Address Line 4</label>
    <input className="form-control" {...register("print.header4")} />
  </div>

  <div className="col-lg-6">
    <label>Address Line 5</label>
    <input className="form-control" {...register("print.header5")} />
  </div>

  <div className="col-lg-6">
    <label>Logo</label>
    <input
      type="file"
      className="form-control"
      onChange={(e) =>
        setValue("print.logo", e.target.files[0])
      }
    />
  </div>


</div>
  <hr />
{/* <div className="row">
  <label><b>Print Settings</b></label>

  <div className="col-lg-4">
    <label>Paper Size</label>
    <select className="form-control" {...register("print.paperSize")}>
      <option value="thermal">Thermal</option>
      <option value="a4">A4</option>
    </select>
  </div>

  <div className="col-lg-4">
    <label>Font</label>
    <select className="form-control" {...register("print.font")}>
      <option value="Consolas">Consolas</option>
      <option value="Arial">Arial</option>
      <option value="Courier New">Courier New</option>
    </select>
  </div>

  <div className="col-lg-4">
    <label>Font Size</label>
    <input
      type="number"
      className="form-control"
      {...register("print.fontSize")}
    />
  </div>

  <div className="col-lg-4 mt-3">
    <input type="checkbox" {...register("print.boldText")} />
    <label className="ms-2">Bold Text</label>
  </div>

  <div className="col-lg-4 mt-3">
    <label>Alignment</label>
    <select className="form-control" {...register("print.alignment")}>
      <option value="left">Left</option>
      <option value="center">Center</option>
      <option value="right">Right</option>
    </select>
  </div>

  <hr />
</div> */}

<div className="row">
  <label><b>Footer Settings</b></label>

  <div className="col-lg-12">
    <label>Footer Message 1</label>
    <input
      className="form-control"
      {...register("print.footerText1")}
    />
  </div>
  <div className="col-lg-12 mb-3">
    <label>Footer Message 2</label>
    <input
      className="form-control"
      {...register("print.footerText2")}
    />
  </div>
  {/* <div className="col-lg-6 mt-3">
    <input type="checkbox" {...register("print.showQrCode")} />
    <label className="ms-2">Show QR Code</label>
  </div> */}

  
</div>

        </div>
        <div className="col-lg-12">
                      <div className="modal-footer-btn">
                        <button
                          type="button"
                          className="btn btn-cancel me-2"
                          data-bs-dismiss="modal"
                          ref={closeButtonRef}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="btn btn-submit">
                          Submit
                        </button>
                      </div>
                    </div>
      </form>

    </div>
  )
}

export default SettingPrint

